export const FETCH_DATA_REQUEST= "FETCH_DATA_REQUEST"
export const FETCH_DATE_CONFIG = "FETCH_DATE_CONFIG";
export const SET_REVENUE_DATE = "SET_REVENUE_DATE";
export const SET_REVENUE_EMPTY = "SET_REVENUE_EMPTY";
export const FETCH_DAILY_REVENUE_DETAILS = "FETCH_DAILY_REVENUE_DETAILS";
export const DISPLAY_ERROR_MESSAGE = "DISPLAY_ERROR_MESSAGE";

export const SET_SELECTEDREVENUE_DATA_REQUEST = "SET_SELECTEDREVENUE_DATA_REQUEST";
export const SET_SELECTEDREVENUE_DATA = "SET_SELECTEDREVENUE_DATA";

export const SUBMITTED_REVENUE_REQUEST = "SUBMITTED_REVENUE_REQUEST";
export const SUBMITTED_REVENUE = "SUBMITTED_REVENUE";
export const RESET_SUBMITTED_AND_ERROR_FLAGS = "RESET_SUBMITTED_AND_ERROR_FLAGS";
export const SET_SHOW_INSTRUCTION_MODEL = "SET_SHOW_INSTRUCTION_MODEL";

export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";

export const UPLOAD_EXCEL_REQUEST = "UPLOAD_EXCEL_REQUEST";
export const UPLOAD_EXCEL_SUCCESS = "UPLOAD_EXCEL_SUCCESS";

export const DATE_CHANGE_FLAG = "DATE_CHANGE_FLAG";
export const DATE_CHANGED = "DATE_CHANGED";

export const FETCH_STATUS_WISE_REVENUE_DATES = "FETCH_STATUS_WISE_REVENUE_DATES";
export const FETCH_REMARK_OPTIONS = "FETCH_REMARK_OPTIONS";

export const CANCEL_CHANGE_REQUEST = "CANCEL_CHANGE_REQUEST";
export const SUBMIT_CHANGE_REQUEST = "SUBMIT_CHANGE_REQUEST";
export const CHANGE_REQUEST_NOT_ALLOWED = "CHANGE_REQUEST_NOT_ALLOWED";

export const SUBMIT_SELECTED_REQUEST = "SUBMIT_SELECTED_REQUEST";
export const SUBMIT_SELECTED_SUCCESS = "SUBMIT_SELECTED_SUCCESS";

export const SET_CHANGE_REQUEST_NUMBER = "SET_CHANGE_REQUEST_NUMBER";
export const TOGGLE_UPLOAD_FILE_MODEL = "TOGGLE_UPLOAD_FILE_MODEL";
export const SET_REVENUE_DATA_LOADING_FLAG = "SET_REVENUE_DATA_LOADING_FLAG";

export const SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE = "SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE";
export const TOGGLE_UNBLOCK_REQUEST_MODEL = "TOGGLE_UNBLOCK_REQUEST_MODEL";
export const SET_SELECT_UNBLOCK_REQUEST_REVENUE = "SET_SELECT_UNBLOCK_REQUEST_REVENUE";
export const UNBLOCK_REQUEST_NOT_ALLOWED = "UNBLOCK_REQUEST_NOT_ALLOWED";
export const SUBMIT_UNBLOCK_REQUEST = "SUBMIT_UNBLOCK_REQUEST";
export const SET_WEEKLY_START_DATE = "SET_WEEKLY_START_DATE";
export const SET_WEEKLY_END_DATE = "SET_WEEKLY_END_DATE";

export const FETCH_WEEKLY_REVENUE_DETAILS = "FETCH_WEEKLY_REVENUE_DETAILS";
export const WEEKLY_DATE_CHANGE_FLAG = "WEEKLY_DATE_CHANGE_FLAG";

export const UPLOAD_WEEKLY_EXCEL_SUCCESS = "UPLOAD_WEEKLY_EXCEL_SUCCESS";

export const SET_RAW_DATE_HANDLER = "SET_RAW_DATE_HANDLER";
export const SET_RAW_DATE = "SET_RAW_DATE";